// extracted by mini-css-extract-plugin
export default {"root":"TextEditor_root__nOZkg","textarea":"TextEditor_textarea__EJVoa","dropdown":"TextEditor_dropdown__kIjB8"};